<template>
	<footer class="w-full bg-[#122633] text-white pt-16 pb-16 px-4">
		<div class="mx-auto flex flex-col items-center gap-10">
			<a href="/" class="flex flex-col items-center" aria-label="Diversey Home">
				<img
					src="/images/light-logo.webp"
					alt="Diversey logo"
					class="w-56"
					width="224"
					height="64"
					loading="lazy"
				/>
			</a>

			<nav aria-label="Footer">
				<ul
					class="flex flex-col md:flex-row text-center md:flex-wrap justify-center gap-x-14 gap-y-2 text-base font-medium text-[#5C707A] list-none -ml-8"
				>
					<li>
						<a
							href="https://www.solenis.com/en/contact/contact-us/"
							class="transition-none focus:outline-none capitalize"
							>{{ getTranslations("contact us") }}</a
						>
					</li>
					<li>
						<a
							href="https://www.solenis.com/en/terms-conditions/"
							class="transition-none focus:outline-none capitalize"
							>{{ getTranslations("terms & conditions") }}</a
						>
					</li>
					<li>
						<a
							href="https://www.solenis.com/en/privacy-statement/"
							rel="noopener"
							target="_blank"
							class="transition-none focus:outline-none capitalize"
							>{{ getTranslations("privacy statement") }}</a
						>
					</li>
				</ul>
			</nav>

			<div
				class="text-xs text-[#676767] text-center max-w-4xl font-normal tracking-wide"
			>
				&copy; {{ new Date().getFullYear() }}
				<a
					href="https://diversey.com/en"
					rel="noopener"
					target="_blank"
					class="transition-none focus:outline-none hover:underline capitalize"
					>{{ getTranslations("diversey, inc") }}</a
				>
				\
				<a
					href="https://www.solenis.com/globalassets/resources/sustainability--regulatory-library/gsbc-english-v2.pdf"
					rel="noopener"
					target="_blank"
					class="transition-none focus:outline-none hover:underline capitalize"
					>{{ getTranslations("global standards of business conduct") }}</a
				>
				\
				<a
					href="https://www.solenis.com/globalassets/resources/sustainability--regulatory-library/supplier-code-of-conduct-v05.pdf"
					rel="noopener"
					target="_blank"
					class="transition-none focus:outline-none hover:underline capitalize"
					>{{ getTranslations("supplier code of conduct") }}</a
				>
				\
				<a
					href="https://ingredients.diversey.com/"
					rel="noopener"
					target="_blank"
					class="transition-none focus:outline-none hover:underline capitalize"
					>{{ getTranslations("u.s. ingredients portal") }}</a
				>
				\
				<a
					href="https://www.solenis.com/en/cookie-policy/"
					rel="noopener"
					target="_blank"
					class="transition-none focus:outline-none hover:underline capitalize"
					>{{ getTranslations("cookies settings") }}</a
				>
			</div>
		</div>
	</footer>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	name: "HomeFooter",
	computed: {
		...mapGetters("staticContent", ["getTranslations"]),
	},
};
</script>
